export default __webpack_public_path__ + "static/media/eth-diamond-purple.dc18f1c9.png";